import { render } from "./viber_icon.vue?vue&type=template&id=37c4d711"
import script from "./viber_icon.vue?vue&type=script&lang=js"
export * from "./viber_icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__